import {
  Button,
  Form,
  FormField,
  Input,
  Modal,
  Textarea,
  InputProps,
  ModalProps,
  NonCancelableCustomEvent,
  SpaceBetween,
} from '@amzn/awsui-components-core';
import { Epic } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../../common/constants';
import { DismissModalReason } from '../../../model/Enum';
import { TiptapOutputType } from '@amzn/awscat-editor';
import EditorWrapper from '../../../editor/EditorWrapper';
import { getText } from '@amzn/awscat-editor';
import { TiptapMenuType } from '../../../editor/utils';

interface Props {
  epics: any[];
  editEpic?: (epic: Epic) => void;
  currentEditingEpic: Epic;
  onDismissClick?: () => void;
  isEditable: boolean;
}

interface State {
  title: TiptapOutputType;
  description: TiptapOutputType;
  titleError: string;
}

export default class EpicEditorForm extends React.Component<Props, State> {
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    const { currentEditingEpic } = this.props;
    this.state = {
      // @ts-expect-error TS2783 - strict migration
      title: '',
      titleError: '',
      ...currentEditingEpic,
    };
  }

  public render() {
    const { onDismissClick, isEditable } = this.props;
    const epicDescEditor = (
      <EditorWrapper
        model={this.state.description}
        readOnly={false}
        onModelChange={this.updateEpicDescription}
        id={'desc-' + this.props.currentEditingEpic.id}
        menuType={TiptapMenuType.OnlyLink}
      />
    );

    const epicTitleEditor = (
      <EditorWrapper
        model={this.state.title}
        readOnly={false}
        onModelChange={this.updateEpicTitle}
        id={'title-' + this.props.currentEditingEpic.id}
        menuType={TiptapMenuType.OnlyLink}
      />
    );
    const formActions = (
      <div>
        <Button onClick={onDismissClick} variant="link">
          {constants.CANCEL_BUTTON_TEXT}
        </Button>
        <Button onClick={this.editEpic} variant="primary">
          {constants.SAVE_BUTTON_TEXT}
        </Button>
      </div>
    );

    return (
      <div className="form-action task-edit-box">
        <Modal
          onDismiss={this.handleDismissModal}
          header={constants.EDIT_EPIC_FORM_HEADER}
          visible={isEditable}
          closeAriaLabel="Close modal"
        >
          <Form actions={formActions} data-testid="edit-epic-form">
            <SpaceBetween direction={'vertical'} size={'s'}>
              <FormField
                errorText={this.state.titleError}
                label={constants.EPIC_TITLE_LABEL}
                stretch
                i18nStrings={{ errorIconAriaLabel: 'Error' }}
              >
                {epicTitleEditor}
              </FormField>
              <FormField
                label={constants.EPIC_DESCRIPTION_LABEL}
                stretch
                i18nStrings={{ errorIconAriaLabel: 'Error' }}
              >
                {epicDescEditor}
              </FormField>
            </SpaceBetween>
          </Form>
        </Modal>
      </div>
    );
  }

  private editEpic = () => {
    const { currentEditingEpic, editEpic, onDismissClick } = this.props;
    const { title, description } = this.state;
    const error = this.validateInput();

    if (!error && editEpic && onDismissClick) {
      editEpic(
        Object.assign(new Epic(), {
          ...currentEditingEpic,
          description,
          title,
        }),
      );
      onDismissClick();
    }
  };

  private validateInput = () => {
    let error: string;
    const { title } = this.state;

    if (!title || getText(title).length <= 0) {
      error = constants.EPIC_TITLE_REQUIRED;
    } else if (getText(title).length > 300) {
      error = constants.EPIC_TITLE_TOO_LONG;
    } else if (this.checkDuplicateTitle(title)) {
      error = constants.DUPLICATE_EPIC_TITLE;
    }

    this.setState({
      // @ts-expect-error TS2454 - strict migration
      titleError: error,
    });

    // @ts-expect-error TS2454 - strict migration
    return error;
  };

  private updateEpicDescription = (content: TiptapOutputType) => {
    this.setState({ description: content });
  };

  private updateEpicTitle = (content: TiptapOutputType) => {
    this.setState({ title: content });
  };

  private checkDuplicateTitle = (title: TiptapOutputType) => {
    const { currentEditingEpic, epics } = this.props;
    return currentEditingEpic
      ? epics.some(
          (epic) => getText(epic.title) === getText(title) && epic.id !== currentEditingEpic.id,
        )
      : epics.some((epic) => getText(epic.title) === getText(title));
  };

  private handleDismissModal = (
    dismissEvent: NonCancelableCustomEvent<ModalProps.DismissDetail>,
  ) => {
    const dismissReason = dismissEvent.detail.reason;
    const { onDismissClick } = this.props;
    if (dismissReason === DismissModalReason.CloseButton) {
      // @ts-expect-error TS2722 - strict migration
      onDismissClick();
    }
  };
}
